import React from 'react';
import {Atom, Plugins, withSystem} from '@packages/systems/wfdl';
import {TListOfElement, TTypeConstructor} from '@packages/systems/wfdl-ast';
import {
  iconName,
  qualify,
  pluginName,
  typeName,
} from '@packages/systems/wfdl-Qualified';
import {createDevlinkAtom} from '@packages/utilities/integrated-types';
import {getChildren, getInPojo, getTag} from '@packages/utilities/data-utils';

const NavbarContainer = Atom.createRender(
  ({attributes, classes, generateAttributes, context, renderChild, data}) => {
    const Tag = getTag(getInPojo(data, ['tag'])) as React.ElementType;
    const navbarContainerClasses = classes.push(`w-container`);

    return (
      <Tag {...generateAttributes(attributes, navbarContainerClasses)}>
        {getChildren(data).map((child) => renderChild(child, context))}
      </Tag>
    );
  }
);

const config = createDevlinkAtom({
  displayName: 'Container',
  showEmpty: true,
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Layout'), iconName('Container')),
  },
  render: NavbarContainer,
  constraints: {
    ancestors: [{is: 'NavbarWrapper', rule: 'ExactlyOne'}],
  },
  fields: {
    tag: withSystem(
      {
        label: 'Tag',
        private: true,
        defaultValue: 'div',
      },
      TTypeConstructor(qualify(pluginName('Basic'), typeName('TagsDropdown')))
    ),
    children: TListOfElement,
  },
});

export default config;
